export default "__VITE_ASSET__DUtvBcWR__"